
(function(template){
  define('vue!optionalClassProgram/components/classComponents/classDescriptionComponent',[
    "Vue",
    "helpers",
    "vuex",

  ], function (
    Vue,
    helpers,
    vuex
  ) {
    return {
      template: template,
      name: "description",
      props: ['cascadeOption','item'],
      data: function () {
        return {}
      },
      computed: _.extend(
        vuex.mapState(['']), {}),
      components: {},
      methods: {},
    }
  })
})('<span> <span class="optionalclass-accordion-body-text"> <strong>{{item.SpaItemName}}</strong>: {{item.eventDate}} {{item.eventStartTime}} - {{item.eventEndTime}} <span class="optionalclass-accordion-body-price" v-if="item.Price && item.OptionalComponent == \'Y\'">${{item.Price}}</span></span> <!-- <span class="optionalclass-accordion-body-text" v-else> <strong>{{item.SpaItemName}}</strong>: {{item.eventDate}} startTime: {{item.eventStartTime}} duration: {{item.ServiceTime}} </span> --> </span>');
